import { X } from 'lucide-react';
import {
  Globe, Code2, Filter, MessageSquare, Mail, Zap, Clock, Play,
} from 'lucide-react';
import { STEP_TYPES } from '../constants.js';

const ICONS = { Globe, Code2, Filter, MessageSquare, Mail, Zap, Clock, Play };

function StepTypeCard({ typeKey, meta, onClick }) {
  const Icon = ICONS[meta.icon] ?? Zap;

  return (
    <button
      onClick={() => onClick(typeKey)}
      style={{
        background: 'var(--surface-2)',
        border: '1px solid var(--border)',
        borderRadius: 10,
        padding: '14px 16px',
        cursor: 'pointer',
        textAlign: 'left',
        transition: 'border-color .15s, box-shadow .15s',
        display: 'flex',
        gap: 14,
        alignItems: 'flex-start',
      }}
      className="hover:border-[var(--primary)] hover:shadow-lg group w-full"
    >
      <div
        style={{
          width: 36, height: 36, borderRadius: 8, flex: '0 0 auto',
          background: `color-mix(in srgb, ${meta.color} 15%, transparent)`,
          color: meta.color,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          transition: 'background .15s',
        }}
        className="group-hover:opacity-90"
      >
        <Icon size={18} />
      </div>

      <div style={{ minWidth: 0 }}>
        <div style={{ fontWeight: 600, fontSize: '.875rem', color: 'var(--text)', marginBottom: 3 }}>
          {meta.label}
        </div>
        <div style={{ fontSize: '.78rem', color: 'var(--text-muted)', lineHeight: 1.4 }}>
          {meta.description}
        </div>
      </div>
    </button>
  );
}

export default function StepModal({ onAdd, onClose }) {
  const groups = {
    core:         { label: 'Core',         items: [] },
    integrations: { label: 'Integrations', items: [] },
  };

  Object.entries(STEP_TYPES).forEach(([key, meta]) => {
    groups[meta.group]?.items.push({ key, meta });
  });

  return (
    <div
      style={{
        position: 'fixed', inset: 0, zIndex: 50,
        background: 'rgba(0,0,0,.7)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        backdropFilter: 'blur(4px)',
      }}
      onClick={onClose}
    >
      <div
        style={{
          background: 'var(--surface)',
          border: '1px solid var(--border)',
          borderRadius: 16,
          width: '100%', maxWidth: 560,
          maxHeight: '85vh',
          overflow: 'hidden',
          display: 'flex', flexDirection: 'column',
          boxShadow: '0 24px 80px rgba(0,0,0,.6)',
        }}
        onClick={e => e.stopPropagation()}
      >
        {/* Header */}
        <div style={{ padding: '20px 24px 16px', borderBottom: '1px solid var(--border)', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div>
            <h2 style={{ margin: 0, fontFamily: 'IBM Plex Mono', fontSize: '1rem', fontWeight: 600, color: 'var(--text)' }}>
              Add a step
            </h2>
            <p style={{ margin: '4px 0 0', fontSize: '.8rem', color: 'var(--text-muted)' }}>
              Steps run in order, top to bottom.
            </p>
          </div>
          <button
            onClick={onClose}
            style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'var(--text-muted)', padding: 4 }}
            className="hover:text-white transition-colors"
          >
            <X size={18} />
          </button>
        </div>

        {/* Content */}
        <div style={{ overflowY: 'auto', padding: '20px 24px 24px', display: 'flex', flexDirection: 'column', gap: 24 }}>
          {Object.entries(groups).map(([gKey, group]) => (
            <div key={gKey}>
              <div style={{
                fontSize: '.7rem', fontWeight: 600,
                color: 'var(--text-muted)',
                textTransform: 'uppercase', letterSpacing: '.06em',
                marginBottom: 10,
              }}>
                {group.label}
              </div>

              <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                {group.items.map(({ key, meta }) => (
                  <StepTypeCard key={key} typeKey={key} meta={meta} onClick={onAdd} />
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
